//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import DefaultEmployeeCardSection from './Employee/Default/DefaultEmployeeCardSection.vue'
import UpdatePasswordModal from '~/components/Shared/UpdatePasswordModal.vue'
import CollaboratorCardSection from '~/components/Dashboard/Employee/Collaborator/CollaboratorCardSection.vue'
import SupervisorCardSection from '~/components/Dashboard/Employee/Supervisor/SupervisorCardSection.vue'
import PROJECT_ROLES from '~/constants/project-roles'
import { PERMISSION_LABELS } from '~/constants/permission-labels'
import { showInfoNotification } from '~/util/notifications'

export default {
  components: {
    UpdatePasswordModal,
    CollaboratorCardSection,
    SupervisorCardSection,
    DefaultEmployeeCardSection,
  },
  mixins: [handleErrorMixin],
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    this.$store.commit('loading', true)
    try {
      await this.setPermissions()
      this.modal.updatePassword = this.$strapi.user.show_change_password_modal
      this.projectRoles = await this.findInActiveProjects()
      this.validateChangeAssigments()
      if (!this.modal.updatePassword) {
        return
      }
      await this.updateInvitation()
    } catch (error) {
      this.handleError(error, 'Ocurrió un error')
    } finally {
      this.$store.commit('loading', false)
    }
  },
  data() {
    return {
      modal: {
        updatePassword: false,
      },
      projectRoles: [],
      permissions: {
        isEnabledInventorySkills: false,
        isEnabledMatchPotential: false,
        isEnabledKitOfSkills: false,
      },
    }
  },
  computed: {
    projectId() {
      if (!this.$strapi.user.project) {
        return null
      }
      return this.$strapi.user.project.id || this.$strapi.user.project
    },
    isVisibleCollaboratorSection() {
      const hastCollaboratorRole = this.projectRoles.some(
        (role) => role.employee_type === PROJECT_ROLES.COLLABORATOR
      )
      return this.$strapi.user.project || hastCollaboratorRole
    },
    isVisibleSupervisorSection() {
      return this.projectRoles.some(
        (role) => role.employee_type === PROJECT_ROLES.SUPERVISOR
      )
    },
    projectsWithActiveValidation() {
      return this.projectRoles
        .filter((role) => role.employee_type === PROJECT_ROLES.SUPERVISOR)
        .map((role) => ({
          id: role.project_id,
          name: role.project_name,
          code: role.project_code,
          status: role.validation_status,
        }))
    },
  },
  methods: {
    async updateInvitation() {
      const [invitation] = await this.$repository.invitation.findAll({
        _where: {
          user: this.user.id,
          active: true,
        },
      })
      if (!invitation) {
        return
      }
      await this.$repository.invitation.update(invitation.id, {
        active: false,
      })
    },
    async findInActiveProjects() {
      return await this.$repository.projectRoles.findInActiveProjects({
        _limit: -1,
      })
    },
    async setPermissions() {
      const [
        { enabled: isEnabledInventorySkills },
        { enabled: isEnabledMatchPotential },
        { enabled: isEnabledKitOfSkills },
      ] = await this.$permissions.allow([
        PERMISSION_LABELS.INVENTORY_SKILLS.BASE,
        PERMISSION_LABELS.MATCH_POTENTIAL.BASE,
        PERMISSION_LABELS.PROJECTS.KIT_OF_SKILLS,
      ])

      this.permissions = {
        isEnabledInventorySkills,
        isEnabledMatchPotential,
        isEnabledKitOfSkills,
      }
    },
    async validateChangeAssigments() {
      await this.projectRoles.forEach(async (projectRole) => {
        if (projectRole.show_notification_change_in_dashboard) {
          showInfoNotification(
            this,
            `<strong>Atención: Se han asignado nuevos colaboradores al proyecto ${projectRole.project_name} para tu revisión.</strong> Por favor, verifica sus formularios para asegurar una validación adecuada de sus habilidades.`
          )
          await this.$repository.projectRoles.update(projectRole.id, {
            show_notification_change_in_dashboard: false,
          })
        }
      })
    },
  },
}
